// Tastatursnarveier. Felles definisjon for håndteringen (KeyboardShortcuts),
// oversikten over snarveier og hint i grensesnittet (meny, knapper).

/** «G» og så en bokstav: gå til en side. Bokstavene følger norske navn. */
export const GO_TO_SHORTCUTS = [
  {
    key: "h",
    to: "/",
    labelKey: "ra.page.dashboard",
    fallback: "Oversikt",
  },
  {
    key: "o",
    to: "/work_items",
    labelKey: "resources.work_items.name",
    fallback: "Oppgaver",
  },
  {
    key: "k",
    to: "/companies",
    labelKey: "resources.companies.name",
    fallback: "Kunder",
  },
  {
    key: "t",
    to: "/contacts",
    labelKey: "resources.contacts.name",
    fallback: "Kontakter",
  },
  {
    key: "j",
    to: "/projects",
    labelKey: "resources.projects.name",
    fallback: "Prosjekter",
  },
  {
    key: "p",
    to: "/prospects",
    labelKey: "crm.prospects.title",
    fallback: "Prospekter",
  },
  { key: "s", to: "/deals", labelKey: "crm.sales.title", fallback: "Pipeline" },
  {
    key: "v",
    to: "/products",
    labelKey: "resources.products.name",
    fallback: "Produkter",
  },
  {
    key: "r",
    to: "/reports",
    labelKey: "crm.reports.title",
    fallback: "Rapporter",
  },
  {
    key: "e",
    to: "/email",
    labelKey: "crm.email.title_page",
    fallback: "E-post",
  },
] as const;

export const goToShortcutFor = (path: string) =>
  GO_TO_SHORTCUTS.find((s) => s.to === path)?.key;

export const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad/.test(navigator.platform);

/** Hendelse som åpner oversikten over snarveier (fra brukermenyen o.l.). */
export const OPEN_SHORTCUTS_EVENT = "mimin:open-shortcuts";

export {
  CREATE_SHORTCUT_ATTR,
  NAV_ROW_ATTR,
} from "@/components/admin/shortcut-attrs";
